import { useGetCollectionByNameQuery } from '@/store/api';
/**
 * Platform-services hook for fetching a single collection by name.
 *
 * Wraps the RTK Query `useGetCollectionByNameQuery` hook with skip logic.
 * Containers should use this hook instead of importing from
 * `@/store/api` directly.
 *
 * @param collectionName - The collection name. Skips the query when falsy.
 *
 * @see src/store/api/cc/collectionsApi.ts
 */
export const useGetCollectionByName = (collectionName) => {
    const { data, isLoading, isFetching, isError, error, refetch, } = useGetCollectionByNameQuery({ collectionName }, { skip: !collectionName });
    const refetchCollectionByName = () => refetch().unwrap();
    return {
        data,
        isLoading,
        isFetching,
        isError,
        error,
        refetchCollectionByName,
    };
};
